// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { ChartData } from '@coa/app/shared/simple-line-chart/components/model/chart-data';

@Component({
  selector: 'coa-dashboard-location-preferences-list-element',
  templateUrl: './dashboard-location-preferences-list-element.component.html',
  styleUrls: ['./dashboard-location-preferences-list-element.component.scss'],
})
export class DashboardLocationPreferencesListElementComponent {
  @Input() number: number;
  @Input() name: string;
  @Input() subName: string;
  @Input() label: string;
  @Input() totalLabel: string;
  @Input() totalValue: number;
  @Input() chartLabel: DateRangeFilter;
  @Input() chartValue: ChartData[];
  @Input() percentageLabel: string;
  @Input() percentageValue: number;
  @Input() small = false;
}
